module.exports = __webpack_public_path__ + "img/stripeTrustBadge.eeddea43.svg";